import React, { createContext, useContext } from 'react';
import { useReviewGate } from '../hooks/useReviewGate';
import { GateStatus } from '../types/gate';

interface ReviewGateContextValue {
  isGated: boolean;
  reviewCount: number;
  requiredCount: number;
  loading: boolean;
  status: GateStatus;
  error: string | null;
  retry: () => Promise<void>;
  setExempt: () => Promise<void>;
  notifyReviewSubmitted: () => void;
  currentSemester: { academicYear: string; semester: string };
}

const ReviewGateContext = createContext<ReviewGateContextValue | null>(null);

export const ReviewGateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const gate = useReviewGate();
  return (
    <ReviewGateContext.Provider value={gate}>
      {children}
    </ReviewGateContext.Provider>
  );
};

export const useReviewGateContext = (): ReviewGateContextValue => {
  const context = useContext(ReviewGateContext);
  if (!context) {
    throw new Error('useReviewGateContext must be used within a ReviewGateProvider');
  }
  return context;
};
